import { createContext } from 'react'

export const ScreensContext = createContext({
  screen: '',
  setScreen: () => {},
  isErrorModalOpen: 0,
  setErrorModal: () => {},
})
